'use client';

import type { ReactNode } from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/cn';
import { Button } from './button';

export function Spinner({ className }: { className?: string }) {
  return <Loader2 aria-label="Loading" className={cn('size-4 animate-spin text-zinc-500', className)} />;
}

export function PageLoading({ label }: { label?: string }) {
  return (
    <div className="flex flex-col items-center gap-3 py-24 text-zinc-500">
      <Spinner className="size-5" />
      {label ? <p className="text-xs">{label}</p> : null}
    </div>
  );
}

export function PageError({
  children,
  onRetry,
}: {
  children: ReactNode;
  onRetry?: () => void;
}) {
  return (
    <div className="flex flex-col items-center gap-3 py-24 text-center">
      <p className="text-sm text-danger">{children}</p>
      {onRetry ? (
        <Button size="sm" onClick={onRetry}>
          Retry
        </Button>
      ) : null}
    </div>
  );
}
